import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import ItemList from 'flarum/common/utils/ItemList';
import extractText from 'flarum/common/utils/extractText';
import setRouteWithForcedRefresh from 'flarum/common/utils/setRouteWithForcedRefresh';

export default class AddApplicationModal extends Modal {
    oninit(vnode) {
        super.oninit(vnode);

        this.app_key = Stream(this.attrs.app_key || '');
    }

    className() {
        return 'AddApplicationModal Modal--small';
    }

    title() {
        return app.translator.trans('xtreh-phoenix.forum.applications.add.title');
    }

    content() {
        return (
            <div className="Modal-body">
                <div className="Form--centered">{ this.fields().toArray() }</div>
            </div>
        );
    }

    fields() {
        const items = new ItemList();

        const keyLabel = extractText(app.translator.trans('xtreh-phoenix.forum.applications.add.key_placeholder'));

        items.add(
            'key',
            <div className="Form-group">
                <input
                    className="FormControl"
                    name="key"
                    type="text"
                    placeholder={keyLabel}
                    aria-label={keyLabel}
                    bidi={this.app_key}
                    disabled={this.loading}
                    required
                />
            </div>,
            50
        );

        items.add(
            'submit',
            <div className="Form-group Form-controls">
                <Button className="Button Button--primary Button--block" type="submit" loading={this.loading}>
                    { app.translator.trans('xtreh-phoenix.forum.applications.add.submit_button') }
                </Button>
            </div>,
            -10
        );

        return items;
    }

    onsubmit(e) {
        e.preventDefault();

        this.loading = true;

        app.store.pushObject({ type: 'application.keys', id: this.app_key() }).save({}, {
            errorHandler: this.onerror.bind(this)
        }).then(() => {
            // there are bug in Mithril that cached items twice rendered if just use this.hide() then we are reinit applications page
            setRouteWithForcedRefresh(app.route('applications'));
        }).catch(() => {
            this.loading = false;
            m.redraw();
        });

        /*
        app.request({
            method: 'PATCH',
            url: app.forum.attribute('apiUrl') + `/applications/keys/${this.app_key()}`,
            errorHandler: this.onerror.bind(this)
        }).then(() => {
            //setRouteWithForcedRefresh(app.route('applications'));
            location.reload();
        }).catch(() => {
            this.loading = false;
            m.redraw();
        });
        */
    }
}
